<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";
  import { createEventDispatcher } from 'svelte';

  export let block;
  let activeLang = localStorage.getItem('lang') || 'lt';
  const dispatch = createEventDispatcher();

  function switchLang(lang) {
      dispatch('langChangeNotify', lang);
  }
</script>

<header id="header" class="header header-scrolled fixed-top" use:links>
  <div class="container-fluid container-xl d-flex align-items-center justify-content-between">
    <a href="/" class="logo d-flex align-items-center">
      <img src="{image(block, 'logo', [null, 50])}" alt="Logo">
    </a>
    <nav id="navbar" class="navbar">
      <ul>
        {#each blocklist(block, 'menu') as item}
          <li><a class="nav-link" href="{url(item, 'link')}" use:link>{text(item, 'link')}</a></li>
        {/each}
        <li>
          <a class="getstarted" href="{url(block, 'button')}" use:link>{text(block, 'button')}</a>
        </li>
	<li>
	  <select class="form-select" style="width: 70px; height: 40px; margin-left: 15px;" bind:value={activeLang} on:change={(ev) => switchLang(ev.target.value)}>
	    <option value="lt">LT</option>
	    <option value="en">EN</option>
	    <option value="de">DE</option>
	    <option value="pl">PL</option>
	    <option value="ru">RU</option>
	  </select>
	</li>
      </ul>
      <i class="bi bi-list mobile-nav-toggle"></i>
    </nav>
    <!-- .navbar -->
  </div>
</header>
